module.exports = __webpack_public_path__ + "img/deer-logo-white.fbafdc16.svg";